export interface GlobalConfig {
  navigation: {
    defaultLob: string;
    activeLob: string;
  };
  packageWith3PP: boolean;
  useLastSearchForMultiLOB: boolean;
  heroImageSrc: string;
  defaultDestination?: string;
  defaultMultipleDestination?: string[];
  destinationDropdownTypeahead?: boolean;
  defaultOrigin?: string;
  defaultMultipleOrigin?: string[];
  selectedProduct?: string;
  halfWizard?: boolean;
  calendarFilterCarrierCode?: string;
  showHeroMobile?: boolean;
}

export enum backgroundImagePosition {
  CENTER = "Center",
  INITIAL = "Initial",
  BOTTOM = "Bottom",
}
